/** Empty-state example prompts — submitted as the first message on click. */
export const SUGGESTIONS = [
  'MERN Stack E-commerce App',
  'Serverless AWS Microservices',
  'Django & React Dashboard',
  'Flutter Mobile App with Firebase',
  'Next.js Blog with Headless CMS',
];
